import { encryptPayload, decryptResponse } from "../utils/apiEnvelope";
import { baseURL } from '../utils/url';
import { hideSiteLoader, showSiteLoader } from './modals';
import { AUTH, LOGOUT, GET_CUSTOMER_LIST } from './type';
import TokenManager from '../utils/TokenManager';
export const Token_Generator = async () => {
    try {
        const fetchResponse = await fetch(baseURL + "token_generator", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const signing = (token, data) => async (dispatch) => {
    try {
        dispatch(showSiteLoader());
        const fetchResponse = await fetch(baseURL + "merchantSignin", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: encryptPayload(data),
        });
        decryptResponse(fetchResponse)
            .then((res) => {
                if (res.message === "Valid Login Details") {
                    sessionStorage.setItem("token", JSON.stringify(true));
                    localStorage.setItem("token_rare", JSON.stringify(true));
                    dispatch({
                        type: AUTH,
                        payload: res,
                    });
                    return res;
                } else {
                    return dispatch({
                        type: AUTH,
                        payload: res,
                    });
                }
            })
            .catch(() => {
                dispatch(hideSiteLoader())
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const logout = () => async (dispatch) => {
	const tokenManager = TokenManager.getInstance();
	tokenManager.clearToken();
	dispatch({ type: LOGOUT });
};
